export default "__VITE_ASSET__X5WN7wX5__"